function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFC300",
  d: "M8.535 13.535c1.953-1.952 1.953-5.118 0-7.07-1.952-1.953-5.118-1.953-7.07 0-1.953 1.952-1.953 5.118 0 7.07 1.952 1.954 5.118 1.954 7.07 0zm20 12.93c-1.952-1.953-5.118-1.953-7.07 0-1.953 1.952-1.953 5.118 0 7.07 1.952 1.953 5.118 1.953 7.07 0 1.953-1.952 1.953-5.118 0-7.07zm-.151-18.081l-1.767-1.767c-.977-.977-2.56-.977-3.536 0L1.617 28.08c-.977.977-.977 2.56 0 3.536l1.767 1.767c.976.976 2.56.976 3.535 0l21.465-21.465c.976-.976.976-2.559 0-3.535z"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0H30V40H0z"
})));
function SvgPercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 40,
    fill: "none",
    viewBox: "0 0 30 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPercent);
export default __webpack_public_path__ + "static/media/percent.3523d5da7cdc627bc06b85811e06ffd6.svg";
export { ForwardRef as ReactComponent };